/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable consistent-return */

import cn from 'classnames';
import { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { requestSearchValue } from '../../redux/actions/main-page';
import { HEADER_LINKS, TO_LINK } from '../../utils/constants/main-header-links';
import Link from '../Link';
import CloseIcon from '../SVGIcons/CloseIcon';
import HeaderLogo from '../SVGIcons/HeaderLogo';
import classes from './mobile-menu.module.scss';

interface IMobileMenuProps {
  shown: boolean;
  onClose: () => void;
}

function MobileMenu({ shown, onClose }: IMobileMenuProps) {
  const dispatch = useDispatch();

  const resetSearch = () => {
    dispatch(requestSearchValue({ searchValue: '' }));
  };

  useEffect(() => {
    if (shown) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = 'auto';
      };
    }
  }, [shown]);

  return (
    <div
      className={cn(classes.menuWrapper, {
        [classes.shownMenuWrapper]: shown,
        [classes.hiddenMenuWrapper]: !shown,
      })}
    >
      <div
        className={cn(classes.menu)}
      >
        <div role="none" onClick={onClose} className={classes.iconContainer}>
          <HeaderLogo className={classes.logoIcon} />
          <button type="button" className={classes.closeBtn}>
            <CloseIcon />
          </button>
        </div>
        <div className={classes.linksContainer}>
          {HEADER_LINKS.map((link) => (
            <Link
              typeColor="black"
              key={link.id}
              title={link.title}
              route={link.to}
              isNavLink={link.isNavLink}
              onClick={resetSearch}
              isActive={link.to === TO_LINK.CATALOG_VACANCIES}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default memo(MobileMenu);
